import { render } from "./PaginationComponent.vue?vue&type=template&id=5b2cbce2&scoped=true&ts=true"
import script from "./PaginationComponent.vue?vue&type=script&lang=ts"
export * from "./PaginationComponent.vue?vue&type=script&lang=ts"

import "./PaginationComponent.vue?vue&type=style&index=0&id=5b2cbce2&lang=scss&scoped=true"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b2cbce2"]])

export default __exports__